export default "__VITE_ASSET__efce9db8__"